<template>
    <div class="matchingConsumption">
        <van-nav-bar
            title=""
            left-text="应用"
            left-arrow
            @click-left="onClickLeft"
            @click-right="showFilterPop = true"
        >
            <template #title>
                <van-tabs
                    v-model="activeIndex"
                    animated
                    @click="toggletab"
                >
                    <template v-for="(item,index) in navData">
                        <van-tab
                            :key="index"
                            :title="item.name"
                        >
                        </van-tab>
                    </template>
                </van-tabs>
            </template>
            <template #right>
                <img class="shaixuan" src="../../../../assets/images/leadingCockpit/shaixuan.png">
            </template>
        </van-nav-bar>
        <filterConditions
            :show-filter-pop.sync="showFilterPop"
            @sureBack="sureBack"
        ></filterConditions>
        <section class="main-wrapper">
            <div class="box-wrapper">
                <keep-alive>
                    <component :is="currentView" :filter-data="filterData"></component>
                </keep-alive>
            </div>
        </section>
    </div>
</template>

<script>
// 原材料消耗
import rawMaterialConsume from './rawMaterialConsume.vue';
// 单方消耗
import unilateralConsumption from './unilateralConsumption.vue';
import filterConditions from '../filterConditions/index';
export default {
    data() {
        return {
            showFilterPop: false,
            currentView: 'rawMaterialConsume',
            activeIndex: 0,
            navData: [
                {
                    name: '原材消耗',
                    value: 'rawMaterialConsume',
                },

                {
                    name: '单方消耗',
                    value: 'unilateralConsumption',
                },
            ],
            filterData: {},
        };
    },
    components: {
        rawMaterialConsume,
        unilateralConsumption,
        filterConditions,
    },
    methods: {
        sureBack(params) {
            this.filterData = params;
        },
        toggletab(index) {
            this.currentView = this.navData[index].value;
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="stylus">
.matchingConsumption
    width 100%
    height 100%
    display flex
    flex-direction column
    .van-nav-bar
        display flex
        .van-nav-bar__title
            max-width 100%
            .van-tabs
                .van-tabs__nav
                            background rgba(0,0,0,0)
                    .van-tab
                        flex-basis auto !important
                        font-size 14rpx
                        margin 0 6rpx
                        line-height 44rpx
                        color rgba(240,240,240,0.5)
                        transition 0.2s
                        &.van-tab--active
                            font-size 16rpx
                            line-height 44rpx
                            color #FFFFFF
                        .van-tab__text
                            white-space nowrap
                    .van-ellipsis
                        text-overflow initial
                    .van-tabs__line
                        display none
                .van-tabs__wrap
                    &:after
                        display none
        .van-ellipsis
            white-space normal
        .van-nav-bar__right
            right 15rpx!important;
            width 0
            .shaixuan
                width 18rpx;
    .main-wrapper
        flex 1
        overflow hidden
        .box-wrapper
            height 100%
            overflow-y auto
</style>
